import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  IconButton,
  Grid,
  Avatar,
} from "@mui/material";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import AddIcon from "@mui/icons-material/Add";
import {
  getTiposVehiculoSinPaginado,
  getColorSinPaginado,
  getModelosSinPaginado,
  getMarcasSinPaginado,
  getEmpresasSinPaginado,
  addVehicleWithImages,
  getDatosMenuPrincipalInvitado,
} from "../../../redux/actions/vehicle.actions";

export const VehicleManagementSection = ({
  existingInvitado,
  onVehiclesUpdate,
  personaid,
  onVehiclePatenteChange,
  initialVehicles = [],
}) => {
  const dispatch = useDispatch();

  // Redux selectors
  const tiposVehiculo = useSelector(
    (state) => state.vehicle.tiposVehiculo || []
  );
  //   console.log('tiposVehiculo', tiposVehiculo);
  const colores = useSelector((state) => state.vehicle.colores || []);
  const modelos = useSelector((state) => state.vehicle.modelos || []);
  const marcas = useSelector((state) => state.vehicle.marcas || []);
  const empresas = useSelector((state) => state.vehicle.empresas || []);
  const vehiculos = useSelector((state) => state.vehicle.vehiculos);
  // Add a separate useEffect to handle the response
  const invitadoData = useSelector((state) => state.vehicle.invitadoData);

  const [open, setOpen] = useState(false);
  const [vehicles, setVehicles] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [vehicleImage, setVehicleImage] = useState("");
  const [currentVehicle, setCurrentVehicle] = useState({
    tipovehiculoid: null,
    origenvehichuloid: null,
    personaid: personaid,
    empresa_seguro: null,
    numero_poliza: null,
    vencimiento_poliza: null,
    marcavehiculoid: null,
    modelovehiculoid: null,
    colorvehiculoid: null,
    cedulaverde: null,
    vtocedula: null,
    comentarios: null,
    patente: null,
  });

  //fetches vehicle image
  const fetchVehicleImage = async (vehicleId) => {
    var axios = require("axios");
    try {
      const token = localStorage.getItem("tokenControl");
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_CONTROL}image-vehiculo-id/${vehicleId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        }
      );
      const imageUrl = URL.createObjectURL(response.data);
      setVehicleImage(imageUrl);
    } catch (error) {
      console.error("Error fetching vehicle image:", error);
      setVehicleImage(null);
    }
  };

  useEffect(() => {
    if (invitadoData?.invitado?.VehiculosData?.length > 0) {
      const latestVehicle = invitadoData.invitado.VehiculosData[0];
      onVehiclePatenteChange(latestVehicle.patente);
    }
  }, [invitadoData]);

  useEffect(() => {
    const fetchExistingVehicles = async () => {
      if (existingInvitado?.tipodocumentoid && existingInvitado?.nrodocumento) {
        try {
          await dispatch(
            getDatosMenuPrincipalInvitado({
              tipodocumentoid: existingInvitado.tipodocumentoid,
              nrodocumento: existingInvitado.nrodocumento,
            })
          );
        } catch (error) {
          console.error("Error fetching vehicles:", error);
        }
      }
    };

    fetchExistingVehicles();
  }, [existingInvitado, dispatch]);

  useEffect(() => {
    if (invitadoData?.invitado?.VehiculosData) {
      const vehiclesData = invitadoData.invitado.VehiculosData;
      // console.log("Vehicles data:", vehiclesData);

      setVehicles(vehiclesData);

      if (vehiclesData.length > 0) {
        const firstVehicle = vehiclesData[0];
        setSelectedVehicle(firstVehicle);
        fetchVehicleImage(firstVehicle.vehiculoid);
      }
    }
  }, [invitadoData]);

  const handleVehicleChange = (event) => {
    const vehicle = vehicles.find((v) => v.vehiculoid === event.target.value);
    setSelectedVehicle(vehicle);
    if (vehicle?.vehiculoid) {
      fetchVehicleImage(vehicle.vehiculoid);
      onVehiclePatenteChange(vehicle.patente);
    }
  };

  useEffect(() => {
    setCurrentVehicle((prev) => ({
      ...prev,
      personaid: personaid,
    }));
  }, [personaid]);

  const [vehicleImages, setVehicleImages] = useState({
    imageCar: null,
    imageGreenCard: null,
    imagePolicy: null,
  });

  useEffect(() => {
    // Fetch all necessary data
    dispatch(getTiposVehiculoSinPaginado());
    dispatch(getColorSinPaginado());
    dispatch(getModelosSinPaginado());
    dispatch(getMarcasSinPaginado());
    dispatch(getEmpresasSinPaginado());
  }, [dispatch]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setCurrentVehicle({
      tipovehiculoid: null,
      origenvehichuloid: null,
      personaid: null,
      empresa_seguro: null,
      numero_poliza: null,
      vencimiento_poliza: null,
      marcavehiculoid: null,
      modelovehiculoid: null,
      colorvehiculoid: null,
      cedulaverde: null,
      vtocedula: null,
      comentarios: null,
      patente: null,
    });
    setVehicleImages({
      imageCar: null,
      imageGreenCard: null,
      imagePolicy: null,
    });
  };

  const handleImageChange = (type, event) => {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setVehicleImages((prev) => ({
          ...prev,
          [type]: reader.result,
        }));
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const handleAddVehicle = () => {
    if (
      !currentVehicle.patente ||
      !currentVehicle.tipovehiculoid ||
      !currentVehicle.numero_poliza ||
      !currentVehicle.vencimiento_poliza
    ) {
      return;
    }

    const newVehicles = [
      ...vehicles,
      {
        ...currentVehicle,
        invitadoid: currentVehicle.personaid,
        images: vehicleImages,
      },
    ];
    setVehicles(newVehicles);
    onVehiclesUpdate(newVehicles);
    // notify about the new patente
    onVehiclePatenteChange(currentVehicle.patente);
    handleClose();
  };

  return (
    <Paper
      elevation={2}
      sx={{
        minWidth: "250px",
        p: 2,
        m: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1,
      }}
    >
      <IconButton
        color="primary"
        sx={{
          width: 120,
          height: 120,
          border: "2px dashed #ccc",
          borderRadius: "8px",
          overflow: "hidden",
          padding: 0,
        }}
      >
        {selectedVehicle && vehicleImage ? (
          <Avatar
            src={vehicleImage}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
            variant="square"
          />
        ) : (
          <AddIcon sx={{ fontSize: 40 }} />
        )}
      </IconButton>

      {vehicles.length > 0 && (
        <FormControl fullWidth sx={{ mb: 1 }}>
          <InputLabel>Vehículo</InputLabel>
          <Select
            value={selectedVehicle?.vehiculoid || ""}
            onChange={handleVehicleChange}
            label="Vehículo"
          >
            {vehicles.map((vehicle) => (
              <MenuItem key={vehicle.vehiculoid} value={vehicle.vehiculoid}>
                {vehicle.patente}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      <Button
        variant="contained"
        color="primary"
        onClick={handleOpen}
        startIcon={<DirectionsCarIcon />}
      >
        Agregar Vehículo
      </Button>

      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>Agregar Vehículo</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            {/* Mandatory fields */}
            <Grid item xs={12} md={6}>
              <TextField
                required
                label="Patente"
                fullWidth
                value={currentVehicle.patente || ""}
                onChange={(e) =>
                  setCurrentVehicle({
                    ...currentVehicle,
                    patente: e.target.value,
                  })
                }
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth required>
                <InputLabel sx={{ backgroundColor: "white", px: 1 }}>
                  Tipo de Vehículo
                </InputLabel>
                <Select
                  value={currentVehicle.tipovehiculoid || ""}
                  onChange={(e) =>
                    setCurrentVehicle({
                      ...currentVehicle,
                      tipovehiculoid: e.target.value,
                    })
                  }
                >
                  {Array.isArray(tiposVehiculo) &&
                    tiposVehiculo.map((tipo) => (
                      <MenuItem
                        key={tipo.tipovehiculoid}
                        value={tipo.tipovehiculoid}
                      >
                        {tipo.nombre}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            {/* Insurance fields */}
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel sx={{ backgroundColor: "white", px: 1 }}>
                  Empresa de Seguro
                </InputLabel>
                <Select
                  value={currentVehicle.empresa_seguro || ""}
                  onChange={(e) => {
                    setCurrentVehicle((prev) => ({
                      ...prev,
                      empresa_seguro: e.target.value,
                    }));
                  }}
                >
                  {empresas?.map((empresa) => (
                    <MenuItem
                      key={empresa.empresaseguroid}
                      value={empresa.empresaseguroid}
                    >
                      {empresa.nombre}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                required
                label="Número de Póliza"
                fullWidth
                value={currentVehicle.numero_poliza || ""}
                onChange={(e) =>
                  setCurrentVehicle({
                    ...currentVehicle,
                    numero_poliza: e.target.value,
                  })
                }
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                required
                label="Vencimiento de Póliza"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={currentVehicle.vencimiento_poliza || ""}
                onChange={(e) =>
                  setCurrentVehicle({
                    ...currentVehicle,
                    vencimiento_poliza: e.target.value,
                  })
                }
              />
            </Grid>

            {/* Vehicle details */}
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel sx={{ backgroundColor: "white", px: 1 }}>
                  Marca
                </InputLabel>
                <Select
                  value={currentVehicle.marcavehiculoid || ""}
                  onChange={(e) =>
                    setCurrentVehicle({
                      ...currentVehicle,
                      marcavehiculoid: e.target.value,
                    })
                  }
                >
                  {marcas?.map((marca) => (
                    <MenuItem
                      key={marca.marcavehiculoid}
                      value={marca.marcavehiculoid}
                    >
                      {marca.nombre}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel sx={{ backgroundColor: "white", px: 1 }}>
                  Modelo
                </InputLabel>
                <Select
                  value={currentVehicle.modelovehiculoid || ""}
                  onChange={(e) =>
                    setCurrentVehicle({
                      ...currentVehicle,
                      modelovehiculoid: e.target.value,
                    })
                  }
                >
                  {modelos?.map((modelo) => (
                    <MenuItem
                      key={modelo.modelovehiculoid}
                      value={modelo.modelovehiculoid}
                    >
                      {modelo.nombre}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel sx={{ backgroundColor: "white", px: 1 }}>
                  Color
                </InputLabel>
                <Select
                  value={currentVehicle.colorvehiculoid || ""}
                  onChange={(e) =>
                    setCurrentVehicle({
                      ...currentVehicle,
                      colorvehiculoid: e.target.value,
                    })
                  }
                >
                  {colores?.map((color) => (
                    <MenuItem
                      key={color.colorvehiculoid}
                      value={color.colorvehiculoid}
                    >
                      {color.nombre}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Images */}
            <Grid item xs={12}>
              <TextField
                type="file"
                label="Foto del Vehículo"
                fullWidth
                onChange={(e) => handleImageChange("imageCar", e)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                type="file"
                label="Cédula Verde"
                fullWidth
                onChange={(e) => handleImageChange("imageGreenCard", e)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                type="file"
                label="Póliza"
                fullWidth
                onChange={(e) => handleImageChange("imagePolicy", e)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            {/* Comments */}
            <Grid item xs={12}>
              <TextField
                label="Comentarios"
                fullWidth
                multiline
                rows={4}
                value={currentVehicle.comentarios || ""}
                onChange={(e) =>
                  setCurrentVehicle({
                    ...currentVehicle,
                    comentarios: e.target.value,
                  })
                }
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button
            onClick={handleAddVehicle}
            variant="contained"
            color="primary"
          >
            Agregar
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};
